import makeSlice from '@web/slices/orderProcessor/sliceMaker'

import {initOrderSheetByAPI} from '../../actions'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(initOrderSheetByAPI.fulfilled, (state, {payload}) => {
            const {verificationKey} = payload

            state.verificationKey = verificationKey
        })
    },
})

export default slice.reducer
